export default __webpack_public_path__ + "static/media/FeverLand_00.fb03031a.png";